import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { AuthService } from '../services/auth.service';

@Injectable({
   providedIn: 'root',
})
export class CabinetGuard  {
   constructor(
      public router: Router,
      public authFire: AngularFireAuth
   ) {}
   async canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): Promise<any> {
      const originalRequestUrl = state.url;
      if (originalRequestUrl.includes('/cabinet')) {
         this.router.navigate([originalRequestUrl.replace('/cabinet', '')]);
         return false;
      }
      return true;
   }
}
